import { render, staticRenderFns } from "./how-to-pay.vue?vue&type=template&id=f821e7da"
import script from "./how-to-pay.vue?vue&type=script&lang=js"
export * from "./how-to-pay.vue?vue&type=script&lang=js"
import style0 from "./how-to-pay.vue?vue&type=style&index=0&id=f821e7da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports